import { useState } from "react";
import { sendPasswordResetToEmail } from "@/lib/auth/passwordResetEmail";

export function SettingsDrawerPasswordResetInline(props: { email: string }) {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  async function send() {
    setMsg(null);
    setBusy(true);
    const r = await sendPasswordResetToEmail(props.email);
    setBusy(false);
    setMsg(
      r.ok
        ? "If this address is in our system, a reset link was sent. Open it on this device to finish."
        : r.message
    );
  }

  if (!props.email.trim()) return null;

  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-900/40 px-3 py-2.5 space-y-2">
      <div className="text-xs font-medium text-slate-700 dark:text-slate-200">Sign-in password</div>
      <p className="text-[11px] text-slate-600 dark:text-slate-400">
        Forgot your password? We will email a secure link to <span className="font-medium">{props.email}</span>.
      </p>
      <button
        type="button"
        disabled={busy}
        onClick={() => void send()}
        className="w-full rounded-lg border border-indigo-300 bg-white px-3 py-1.5 text-xs font-semibold text-indigo-800 hover:bg-indigo-50 disabled:opacity-50 dark:border-indigo-700 dark:bg-slate-800 dark:text-indigo-200 dark:hover:bg-indigo-950/50"
      >
        {busy ? "Sending…" : "Email password reset link"}
      </button>
      {msg ? <p className="text-[11px] text-slate-600 dark:text-slate-400">{msg}</p> : null}
    </div>
  );
}
